import { Component, OnInit } from "@angular/core";
import { AuthService } from "src/app/services/auth.service";
import { Router } from "@angular/router";
import { State } from "src/app/reducers";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { ThemeService } from '../../services/ThemeService';
import { AboutDialogComponent } from '../AboutthisApp/about-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: "app-nav",
  templateUrl: "./nav.component.html",
  styleUrls: ["./nav.component.scss"],
})
export class NavComponent implements OnInit {
  userRole: string = '';
  isDarkMode$ = this.themeService.isDarkMode$;
  constructor(
    private themeService: ThemeService,
    private dialog: MatDialog,
    private authService: AuthService,
    private router: Router,
    private store: Store<State>
    
    
  ) {

    this.userRole = this.authService.getRole();
  }
  
  username;
  permission;
  
  permissions$: Observable<any> = this.store.select(
    (state) => state.permissions
  );

  openAboutDialog(): void {
    this.dialog.open(AboutDialogComponent, {
      width: '800px',
      maxHeight: '90vh'
    });
  }
  toggleDarkMode() {
    this.themeService.toggleDarkMode();
  }

  ngOnInit() {
    this.authService.isAuthenticated().then(() => {
      this.username = this.authService.username;
      this.permission = this.authService.role;
    });
  }

  logout() {
    this.authService.logout();
    this.router.navigate(["/login"]);
  }
}
